// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"7f1c5816","606":"9249ef8d","726":"103390bc","896":"6bc1bab3"}[chunkId] + ".chunk.js";
};